import React from 'react';
import {Page, Button, Spinner} from '../../components';
import {Query} from '../../utils';
import QueryTable from './data-table.js';
import classNames from 'classnames';
import trash from './images/trash-3.svg';
import sprintf  from 'yow/sprintf'; 

export default class extends React.Component {


    constructor(props) {
        super(props);
        this.state = {};
        this.query = new Query();
        this.state.rows = undefined;
        this.state.loading = true;
        this.state.columns = [];
        this.state.selection = {};

        let addColumn = (column) => {
            if (typeof column == 'function')
                column = column();

            this.state.columns.push(column);
        }

        addColumn({
            name: 'Ticker',
            value: (row) => row == undefined ? '-' : row.symbol,
            text: (row) => row.symbol       

        });

        addColumn({
            name: 'Namn',
            value: (row) => `${row.name} (${row.exchange})`,
            text: (row) => row == undefined || row.name == null ? '-' : row.name     
        });

        addColumn({
            name: 'Börs',
            align: 'left',
            value: (row) => row.exchange
        });



        addColumn(() => {

            let format = (date) =>  {
                if (date == null)
                    return '';
                date = new Date(date);
                return sprintf('%04d-%02d-%02d %02d:%02d', date.getFullYear(), date.getMonth()+1, date.getDate(), date.getHours(), date.getMinutes());
            }
            return ({
                name: 'Senast kurs',
                text: (row) => format(row.date),
                value: (row) => row.date
    
            });
        });


        addColumn(() => {

            let format = (date) =>  {
                if (date == null)
                    return '';
                date = new Date(date);
                return sprintf('%04d-%02d-%02d %02d:%02d', date.getFullYear(), date.getMonth()+1, date.getDate(), date.getHours(), date.getMinutes());
            }
            return ({
                name: 'Senast uppdaterad',
                text: (row) => format(row.timestamp),
                value: (row) => row.timestamp
    
            });
        });

        addColumn(() => {



            let renderContent = (row, rowIndex, columnIndex) => {

                let props = {};


                props.index = rowIndex;
                props.className = 'btn';

                props.onClick =  async (event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    let row = this.state.rows[rowIndex];
                    let sql = `DELETE FROM stocks WHERE symbol = '${row.symbol}'`;

                    console.log(sql);

                    await this.query.sql(sql);
                    await this.fetch();


                };

                return (
                    <button {...props}>
                        <img src={trash}></img>
                    </button>
                );

            }

            return (
                {
                    name:'',
                    align:'center',
                    content:  renderContent
                }

            )
        });

    }





    async fetch() {
        try {
            let rows = await this.query.fetch('SELECT * FROM stocks LIMIT 10000');
            this.setState({rows:rows, selection: {}, loading:false});

    
        }
        catch(error) {
            console.log(error.message);

        }
    }

    async componentDidMount() {
        await this.fetch();
    }




    renderTable() {

        let props = {};
        props.selectionStyle = 'single';
        props.columns = this.state.columns;
        props.rows = this.state.rows;
        props.sortBy = 0;   
        props.sortOrder = 'ascending';
        props.onSelectionChange = (rows) => {
        };
        return <QueryTable {...props}></QueryTable>

    }



    renderSpinner() {
        let style = {};
        style.marginLeft = 'auto';
        style.marginRight = 'auto';
        style.display = 'flex';
        style.alignItems = 'center';

        return (
            <Spinner style={style} animation="grow" />
        );
    }

    render() {


        if (this.state.loading) {
            return (
                <Page>
                    {this.renderSpinner()}
                 </Page>
            );
    
        }

        if (this.state.rows) {
            return (
                <Page>
                    {this.renderTable()}
                    <Button link={-1}>
                        Tillbaka
                    </Button>
                </Page>

            );
        }

        return (
            <Page>
                <Button link={-1}>
                    Tillbaka
                </Button>
            </Page>
        );


    }
}



